import { useState, useRef } from 'react';
import searchGrey from '../../assets/images/search-grey.svg';

const SearchInput = ({
    placeholder,
    onChange,
    value,
    type,
    className,
    currentSetSearch = '',
    withSearchFilter = false,
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);
    const [localValue, setLocalValue] = useState(value || '');

    const handleClear = () => {
        onChange({
            target: { value: '' },
        }); // Clear input value
        setLocalValue('');
    };

    const handleChange = (e) => {
        setLocalValue(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearchFilter({
                target: { value: localValue },
            });
        }
    };

    const handleSearchFilter = () => {
        onChange({
            target: { value: localValue },
        });
    };

    return (
        <>
            <input
                onChange={handleChange}
                value={localValue}
                type={type}
                className={`${className} ${
                    currentSetSearch && value ? 'focused' : ''
                }`}
                placeholder={placeholder}
                ref={inputRef}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onKeyDown={handleKeyDown}
            />
            {withSearchFilter && !(currentSetSearch && value) && (
                <button
                    type="button"
                    aria-label="Search"
                    onClick={handleSearchFilter}
                    className="common-search-filter__search"
                >
                    <img src={searchGrey} alt="search" />
                </button>
            )}
            {currentSetSearch && value && (
                <button
                    className="common-search-filter__clear"
                    onClick={handleClear}
                    aria-label="Clear search"
                />
            )}
        </>
    );
};

export default SearchInput;
